<div class="partner-area ptb-70 bg-fafafb">
  <div class="container">
    <div class="row align-items-center">
      @for (Item of partnerItem; track Item) {
        <div class="col-lg-2 col-6 col-sm-4 col-md-4">
          <div class="single-partner-item">
            <img [src]="Item.img" alt="Devotory technology partner">
          </div>
        </div>
      }
    </div>
  </div>
</div>